import { Link, useLocation, useNavigate } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import useDocumentMeta from '@/hooks/useDocumentMeta';

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();

  useDocumentMeta({
    title: '页面不存在 - 丝瓜视频',
    description: '你访问的页面不存在或已被移除，返回丝瓜视频首页继续浏览电影、电视剧与综艺节目。',
    keywords: '丝瓜视频,404,页面不存在',
  });

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-[1360px] flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
        <div className="relative">
          <span className="font-heading text-[120px] font-extrabold leading-none text-primary-100 md:text-[180px]">404</span>
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-500 text-background-50 md:h-20 md:w-20">
              <i className="ri-emotion-sad-line text-3xl md:text-4xl" />
            </span>
          </span>
        </div>
        <h1 className="mt-6 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">抱歉，页面走丢了</h1>
        <p className="mt-3 max-w-md text-sm text-foreground-600 md:text-base">
          你访问的页面可能已被移除或输入了错误的地址。
        </p>
        <p className="mt-2 max-w-full truncate rounded-md bg-background-100 px-3 py-1.5 font-mono text-xs text-foreground-500">
          {location.pathname}
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-5-line" /> 返回首页
          </Link>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 font-label text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-arrow-go-back-line" /> 返回上一页
          </button>
        </div>
      </div>
    </SiteLayout>
  );
}